import './SectorsSection.css'

export default function SectorsSection() {
  return (
    <section className="section" id="setores">
      <div className="section-inner">
        <div className="section-eyebrow">Onde atuamos</div>
        <h2 className="section-title">Soluções pensadas para cada realidade</h2>
        <p className="section-desc">
          Atuamos com profundidade em dois universos — gestão pública e gestão privada — com o mesmo compromisso: entregar resultados reais através de tecnologia, transparência e decisões baseadas em dados.
        </p>

        <div className="sectors-grid">
          <a href="#" className="sector-card publico">
            <div className="sector-icon">🏛️</div>
            <div>
              <div className="sector-tag">Setor Público</div>
              <h3>Gestão eficiente para prefeituras e autarquias</h3>
            </div>
            <p>Sistemas web e apps de gestão construídos para instituições públicas, com indicadores e análises que apoiam decisões responsáveis.</p>
            <div className="sector-link">Ver soluções públicas →</div>
          </a>
          <a href="#" className="sector-card privado">
            <div className="sector-icon">📊</div>
            <div>
              <div className="sector-tag">Setor Privado</div>
              <h3>Gestão 360° do seu negócio com indicadores em tempo real</h3>
            </div>
            <p>Sistemas e apps personalizados, com gestão por resultados e os KPIs que importam para a sua operação crescer com previsibilidade.</p>
            <div className="sector-link">Ver soluções privadas →</div>
          </a>
        </div>
      </div>
    </section>
  )
}
